module.exports = __webpack_public_path__ + "static/media/fvs_fremdlinge_73.45b7a84a.jpg";